<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
        variant="danger"
        :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Error Ketika mengambil data pegawai
      </h4>
      <div class="alert-body">
        Tidak ditemukan pegawai dengan ID tertera. Cek Kembali
        <b-link
            class="alert-link"
            :to="{ name: 'home'}"
        >
          Halaman Utama
        </b-link>
      </div>
    </b-alert>

    <profil-edit
        v-if="userData"
        :user-data="userData"
        :bidangOptions="bidangOptions"
        class="mt-2 pt-75"
    />
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import {ref, onUnmounted} from '@vue/composition-api'
import store from '@/store'
import storeModule from './ProfileStoreModule'
import ProfilEdit from './ProfilEdit.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    ProfilEdit,
  },
  data() {
    return {
      pengawasOptions: [],
      bidangOptions : []
    }
  },
  setup() {
    const userData = ref(null)

    const APP_STORE_MODULE_NAME = 'app-profil'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    store.dispatch(APP_STORE_MODULE_NAME + '/fetch')
        .then(response => {
          userData.value = response.data.data
        })
        .catch(error => {
          if (error.response.status === 404) {
            userData.value = undefined
          }
        })

    return {
      userData,
    }
  },
  methods : {
    bidangOptionsGetters() {
      store
          .dispatch('app-profil/bidang', {
            perPage: 1000,
          })
          .then(response => {
            const data = []
            for (let key in response.data.data.data) {
              data.push({
                'label': response.data.data.data[key].nama,
                'value': response.data.data.data[key].id,
              });
            }
            this.bidangOptions = data
          })
          .catch((error) => {
            console.log(error)
          })
    },
  },
  created() {
    this.bidangOptionsGetters()
  }
}
</script>

<style>

</style>
